import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AdminService } from '../../services/admin.service';
import { InstituteDTO } from '../../model/institute.entity';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Dropdown } from 'primeng/dropdown';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';


@Component({
  selector: 'tandc-institute',
  templateUrl: './institute.component.html',
  styleUrls: ['./institute.component.scss']
})
export class InstituteComponent implements OnInit {

  instituteList: InstituteDTO[] = [];
  model: InstituteDTO = new InstituteDTO();
  instituteTypelist: Dropdown[] = [];
  showModal: boolean = false;
  modalTitle: string = "";
  stateOptions:any[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }];
  @ViewChild('dt')
  dt!: Table;
  showInstituteTypeError = false;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
  private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getInstitute().subscribe((x) => {
      this.instituteList = x.value;
    });
    this.service.getInstituteType().subscribe((x) => {
      this.instituteTypelist = x.value;
    });
  }

  addModal() {
    this.model = new InstituteDTO();
    this.showModal = !this.showModal;
    this.modalTitle =
      this.translate.instant('commonbtn.add') +
      ' ' +
      this.translate.instant('Master.institute');
  }

  save(data: InstituteDTO) {
    if (data.id > 0) {
      this.service.updateInstitute(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      });
    } else {
      this.service.saveInstitute(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }

  delete(data: InstituteDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deleteInstitute(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

  edit(data: InstituteDTO) {
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.institute');
    this.model = data;
    this.showModal = !this.showModal;
  }

  handleSaveClick() {
  if (!this.model.instituteTypeId) {
    this.showInstituteTypeError = true;
    return; 
  }

  this.showInstituteTypeError = false;
  this.save(this.model); 
}

    onToggleStatus(item: InstituteDTO) {
  const updatedItem = { ...item }; 
  this.service.updateInstitute(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }
    downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('institute').subscribe(blob => {
      this.downloadFile(blob, `institute-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }

}
